import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AuthView from '@/views/AuthView.vue'
import AdminView from '@/views/AdminView.vue'
import RestrictedView from '@/views/RestrictedView.vue'

const routes = [
  {
    path: '/',
    name: 'feathers and fireflies',
    component: HomeView
  },
  {
    path: '/auth',
    name: 'feathers and fireflies auth',
    component: AuthView
  },
  {
    path: '/admin',
    name: 'feathers and fireflies admin',
    component: AdminView,
  },
  {
    path: '/restricted',
    name: 'feathers and fireflies restricted',
    component: RestrictedView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from , next) => {
  document.title = to.name;
  next();
});

export default router
